/* coupon.js (CONTRACT-SITE §9.3): "Have a code?" on the plan panes, the celebration, the sticky mirror, and the code that
   rides on every checkout. Figures = the server's cents; text nodes only; ONE live region; audio only from a gesture. */
(function () {
'use strict';
var STATE_KEY = 'clozo_coupon', SOUND_KEY = 'clozo_sound', CODE_RE = /^[A-Za-z0-9_-]{2,32}$/, VALIDATE = '/api/public/coupon/validate', TIMEOUT_MS = 8000, COUNT_MS = 700;
var CYCLE = { monthly: 'month', yearly: 'year' }, E6 = 'We couldn’t check the code. Try again in a moment.', NOTICE_KEY = 'clozo_coupon_notice';
var D = document, root = D.currentScript, state = null, audio = null, live = null, celP = null, KL = 'data-pay-code-list';
var REASON = { coupon_invalid: 'unknown', invalid_request: 'unknown', coupon_expired: 'expired', coupon_exhausted: 'exhausted', coupon_disabled: 'disabled', coupon_inactive: 'inactive', affiliates_disabled: 'disabled' };
function $(s, e) { return (e || D).querySelector(s); }
function $$(s, e) { return [].slice.call((e || D).querySelectorAll(s)); }
function mk(t, c, x) { var e = D.createElement(t); if (c) e.className = c; if (x) e.textContent = x; return e; }
function tx(s) { return D.createTextNode(s); }
function at(e, n) { return e.getAttribute(n); }
function rm() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
function read() { try { var v = JSON.parse(sessionStorage.getItem(STATE_KEY)); return v && v.code ? v : null; } catch (e) { return null; } }
function write(v) { state = v; try { sessionStorage.setItem(STATE_KEY, JSON.stringify(v)); } catch (e) {} }
function soundOff() { try { return localStorage.getItem(SOUND_KEY) === '0'; } catch (e) { return false; } }
function token() { try { return window.InterviewAuth && InterviewAuth.token(); } catch (e) { return null; } }
function fmt(c) { return (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
function money(c) { return '$' + fmt(c); }   // X72: the pricing surfaces' own format (the panes say $199)
function pct() { return String(state.percentBps / 100); }
function plan(b) { return at(b, 'data-pay-code'); }
function cardOf(b) { return b.closest('.pricing-card'); }
function now() { return new Date().toISOString(); }
function urlCode() { try { return clozoReferral.urlCode(); } catch (e) { return null; } }
function track(n, p) { try { clozo.track(n, p); } catch (e) {} }
function say(t) { try { if (!live) { live = mk('p', 'pay-code-live'); live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); ($('.pricing-grid') || D.body).appendChild(live); } live.textContent = ''; setTimeout(function () { live.textContent = t; }, 50); } catch (e) {} }
function afterLoad(fn) { function idle() { window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 1000 }) : setTimeout(fn, 1000); } D.readyState === 'complete' ? idle() : addEventListener('load', idle); }
function keep(e) { if (at(e, KL) === null) e.setAttribute(KL, e.textContent); return at(e, KL); }
function empty(e) { while (e.firstChild) e.removeChild(e.firstChild); }
function msg(b, t) {
  var m = $('.pay-code-msg', b), f = $('.pay-code-input', b);
  m.id = 'pay-code-msg-' + plan(b); m.textContent = t || '';
  if (t) { f.setAttribute('aria-invalid', 'true'); f.setAttribute('aria-describedby', m.id); } else { f.removeAttribute('aria-invalid'); f.removeAttribute('aria-describedby'); }
}
function open(b) {
  $$('.pay-code').forEach(function (o) { if (o !== b) close(o, 1); });
  var t = $('.pay-code-toggle', b), f = $('.pay-code-input', b);
  t.setAttribute('aria-expanded', 'true'); t.hidden = true; $('.pay-code-form', b).hidden = false;
  if (!f.value && !state) { try { f.value = clozoReferral.code() || ''; } catch (e) {} }   // a STORED code: only on this explicit action (CPN-MS-12)
  f.focus(); afterLoad(loadCelebrate);
}
function close(b, quiet) { var t = $('.pay-code-toggle', b); $('.pay-code-form', b).hidden = true; t.hidden = false; t.setAttribute('aria-expanded', 'false'); msg(b); if (!quiet) t.focus(); }
function busy(b, on) {
  var a = $('.pay-code-apply', b);
  $('.btn-label', a).textContent = on ? 'Checking…' : 'Apply'; a.disabled = on; a.classList.toggle('is-loading', on);
  $('.pay-code-input', b).readOnly = on; $('.pay-code-form', b).setAttribute('aria-busy', String(on));
}
function armAudio() { if (soundOff()) return; var AC = window.AudioContext || window.webkitAudioContext; if (AC) try { audio = audio || new AC(); if (audio.state === 'suspended') audio.resume(); } catch (e) {} }
function chime() {
  try {
    var t = audio.currentTime, m = audio.createGain(); m.gain.value = 0.6; m.connect(audio.destination);
    [[659.25, t, t + 0.16], [987.77, t + 0.14, t + 0.36]].forEach(function (n) {
      var o = audio.createOscillator(), g = audio.createGain(); o.frequency.value = n[0];
      g.gain.setValueAtTime(0.0001, n[1]); g.gain.exponentialRampToValueAtTime(0.18, n[1] + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, n[2]);
      o.connect(g); g.connect(m); o.start(n[1]); o.stop(n[2] + 0.02);
    });
  } catch (e) {}
}
function syncSound() { var on = !soundOff(); $$('.pay-code-sound').forEach(function (s) { s.setAttribute('aria-checked', String(on)); $('.pay-code-sound-on', s).hidden = !on; $('.pay-code-sound-off', s).hidden = on; }); }
function toggleSound() { var on = soundOff(); try { localStorage.setItem(SOUND_KEY, on ? '1' : '0'); } catch (e) {} syncSound(); if (on) armAudio(); }
function validate(code) {
  var ctrl = window.AbortController && new AbortController(), h = { 'Content-Type': 'application/json' }, tok = token(), rt = window.__clozoRuntime;
  if (tok) { h.Authorization = 'Bearer ' + tok; }   // CPN-UX-05: a live session is checked at Apply
  var timer = ctrl && setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS);
  function fail(s, c) { try { rt.reportFailure('coupon', { path: VALIDATE, method: 'POST', status: s, code: c, network: !s }); } catch (e) {} }
  return fetch(VALIDATE, { method: 'POST', credentials: 'omit', headers: h, body: JSON.stringify({ code: code }), signal: ctrl ? ctrl.signal : undefined }).then(function (r) {
    clearTimeout(timer);
    return r.json().then(null, function () { return null; }).then(function (d) {
      var c = d && !d.valid ? d.code || d.error : null;
      if (r.status === 429) { fail(429, c); throw { status: 429 }; }
      if (!d || r.status >= 500) { fail(r.status, c); throw { network: true }; }
      if (r.ok && d.valid) { if (typeof d.signedIn !== 'boolean') d.signedIn = !!tok; return d; }
      fail(r.status, c);
      return { valid: false, reason: REASON[c] || 'server', message: d.message || E6 };
    });
  }, function () { clearTimeout(timer); fail(0); throw { network: true }; });
}
function apply(res, src) {
  write({ applied: true, code: res.code, kind: res.kind, percentBps: res.percentBps, prices: res.prices, providers: res.providers || {}, src: src, at: now(), celebrated: false, signedIn: res.signedIn === true });
  $$('[data-coupon-input]').forEach(function (i) { i.value = res.code; });
  render({ motion: src === 'typed', say: 1 });
  track('coupon_applied', { source: src, kind: res.kind });
}
function paintPrice(card, pl, mode) {   // list | start | final — CPN-UX-03: a link state keeps the list figure until celebrate()
  var e = $('.price', card), p = state.prices[pl], list, s;
  if (!e || !p) return;
  list = keep(e); empty(e);
  if (mode !== 'list') {   // CPN-UX-30: "was … , now for your first …" for screen readers
    s = mk('s', 'pay-code-was' + (mode === 'start' ? ' is-entering' : '')); s.appendChild(mk('span', 'pay-code-sr', 'was ')); s.appendChild(tx(list));
    e.appendChild(s); e.appendChild(mk('span', 'pay-code-sr', ', now for your first ' + CYCLE[pl] + ', '));
    if (mode === 'start') requestAnimationFrame(function () { s.classList.remove('is-entering'); });
  }
  e.appendChild(tx('$' + fmt(mode === 'final' ? p.firstCycleCents : p.listCents)));
}
function countDown(card, pl) {
  var e = $('.price', card), p = state.prices[pl], n = e && e.lastChild, t0 = 0;
  if (!p || !n || rm() || n.nodeValue === '$' + fmt(p.firstCycleCents)) return;   // never back up
  (function step(ts) {
    t0 = t0 || ts; var k = Math.min(1, (ts - t0) / COUNT_MS);
    n.nodeValue = '$' + fmt(k < 1 ? Math.round(p.listCents - (p.listCents - p.firstCycleCents) * (1 - Math.pow(1 - k, 3))) : p.firstCycleCents);
    if (k < 1) requestAnimationFrame(step);
  })(0);
}
function render(o) {
  if (!state || !state.applied) return;
  o = o || {};
  var P = pct(), C = state.code.toUpperCase(), line = null, j = $('[data-coupon-join]');
  var mode = state.celebrated || rm() ? 'final' : o.motion ? 'start' : state.src === 'link' ? 'list' : 'final';
  $$('.pay-code').forEach(function (b) {
    var pl = plan(b), p = state.prices[pl], cy = CYCLE[pl], card = cardOf(b), ch = $('.pay-code-chip', b), dsc;
    if (!p) return;
    b.classList.remove('is-pending'); $('.pay-code-toggle', b).hidden = true; $('.pay-code-form', b).hidden = true; msg(b);
    $('.pay-code-applied', b).hidden = false; ch.textContent = state.code; ch.setAttribute('tabindex', '-1');
    $('.pay-code-line', b).textContent = (state.src === 'link' ? 'The code ' + C + ' from your link is applied' : 'Code ' + C + ' applied') + ' — ' + P + '% off your first ' + cy + '.';
    $('.pay-code-sub', b).textContent = 'Your first ' + cy + ' is ' + money(p.firstCycleCents) + ', then ' + money(p.listCents) + '. With the free trial, the discount is on the first charge.';
    var big = $('.pay-code-big', b);   // R100/X70: the drop, large, right beside the code box
    if (!big) { big = mk('span', 'pay-code-big'); big.setAttribute('aria-hidden', 'true'); $('.pay-code-applied', b).insertBefore(big, $('.pay-code-applied', b).firstChild); }
    empty(big); big.appendChild(mk('s', '', money(p.listCents))); big.appendChild(tx(' → ')); big.appendChild(mk('b', '', money(p.firstCycleCents)));
    line = line || $('.pay-code-line', b).textContent;
    if (!card) return;
    card.classList.add('has-code');
    if (!$('.pay-code-badge', card)) { card.appendChild(mk('span', 'pay-code-badge')).setAttribute('aria-hidden', 'true'); }
    $('.pay-code-badge', card).textContent = P + '% off your first ' + cy;   // R100
    if ((dsc = $('.plan-price .desc', card)) && mode !== 'list') { keep(dsc); dsc.textContent = 'for your first ' + cy; }   // CPN-UX-01; UX-B1: never beside the list figure
    paintPrice(card, pl, mode);
  });
  if (j && state.kind === 'affiliate') { j.textContent = 'Your code ' + C + ' is saved for your first plan: ' + P + '% off your first month or year.'; j.hidden = false; }   // CPN-UX-13
  syncSound();
  if (o.say && line) say(line);
  renderSticky();
}
function renderSticky() {
  var bar = D.getElementById('stickyCta'), css = root && at(root, 'data-coupon-css'), t, sel, lab;
  if (!bar || !state || !state.applied) return;
  if (css && !$('link[href*="/assets/css/coupon.css"]')) { t = mk('link'); t.rel = 'stylesheet'; t.href = css; D.head.appendChild(t); }
  t = $('.sticky-cta-text', bar);
  bar.classList.add('has-code');   // R108/X73: on a phone the menu anchors to the bar, never past the screen edge (remove() clears .has-code)
  if (t && !$('.pay-code-pill', bar)) { var pill = mk('span', 'pay-code-pill', pct() + '% off'); pill.appendChild(mk('span', 'pay-code-pill-x', ' applied')); t.parentNode.insertBefore(pill, t.nextSibling); }   // R108: a short "20% off" on a phone
  function mirror(e, pl, name) {   // R108/X72: plan name, first-cycle price, then "first month" or "first year" — never read as the renewal price
    var p = state.prices[pl], list;
    if (!e || !p) return;
    list = keep(e); empty(e);
    if (name) { e.appendChild(mk('span', 'dd-price', name)); return e.appendChild(tx(' ' + money(p.firstCycleCents) + ' first ' + CYCLE[pl])); }
    e.appendChild(mk('s', '', list)); e.appendChild(tx(' ' + money(p.firstCycleCents) + ' first ' + CYCLE[pl]));
  }
  $$('.plan-dropdown-item', bar).forEach(function (it) { if (state.prices[at(it, 'data-value')]) it.classList.add('has-code'); mirror($('.dd-item-price', it), at(it, 'data-value')); });
  sel = $('.plan-dropdown-item.selected', bar); lab = $('.dd-label', bar);
  if (sel && lab && CYCLE[at(sel, 'data-value')]) mirror(lab, at(sel, 'data-value'), $('.dd-item-name', sel).textContent);
}
function remove(reason, quiet) {
  var b = D.activeElement && D.activeElement.closest && D.activeElement.closest('.pay-code'), j = $('[data-coupon-join]');
  write({ code: state && state.code, removed: true, at: now() });
  $$('.pay-code').forEach(function (x) { var t = $('.pay-code-toggle', x); x.style.minHeight = ''; x.classList.remove('is-pending'); t.hidden = false; t.setAttribute('aria-expanded', 'false'); $('.pay-code-form', x).hidden = true; $('.pay-code-applied', x).hidden = true; msg(x); });
  $$('[data-coupon-input]').forEach(function (i) { i.value = ''; });
  $$('.has-code').forEach(function (c) { c.classList.remove('has-code'); });
  $$('.pay-code-badge, .pay-code-pill, .pay-code-big, .pay-code-notice').forEach(function (n) { n.remove(); });
  $$('[' + KL + ']').forEach(function (e) { e.textContent = at(e, KL); e.removeAttribute(KL); });
  if (j) j.hidden = true;
  track('coupon_removed', { reason: reason });
  if (!quiet) { say('Code removed.'); if (b) $('.pay-code-toggle', b).focus(); }
}
function loadCelebrate() {
  if (window.clozoIgnition) return Promise.resolve(window.clozoIgnition);
  return celP || (celP = new Promise(function (res) {
    var src = root && at(root, 'data-celebrate-src'), s = mk('script');
    if (!src) return res(null);
    s.src = src; s.async = true; s.onload = function () { res(window.clozoIgnition || null); }; s.onerror = function () { celP = null; res(null); };
    D.head.appendChild(s);
  }));
}
function celebrate(card, opts) {   // once per code per session
  if (!state || !state.applied || state.celebrated) return;
  state.celebrated = true; write(state);
  if (opts.gesture && audio && !soundOff()) chime();   // CPN-UX-12: a typed Apply chimes under reduced motion too; E2E-02: the switch always decides
  var pr = card && $('.plan-price', card), off = pr && opts.gesture ? pr.getBoundingClientRect() : null, nav = 80;
  /* R100/X70: a typed code lives ~1,000 px below the price — bring the price into view first, so the drop happens where it is seen */
  if (off && (off.top < nav || off.bottom > innerHeight)) { try { pr.scrollIntoView({ behavior: rm() ? 'auto' : 'smooth', block: 'center' }); } catch (e) { pr.scrollIntoView(); } }
  if (rm()) return;
  setTimeout(function () {
    $$('.pay-code').forEach(function (b) {
      var c = cardOf(b), d; if (!c) return;
      if (!$('.pay-code-was', c)) paintPrice(c, plan(b), 'start');
      if ((d = $('.plan-price .desc', c))) { keep(d); d.textContent = 'for your first ' + CYCLE[plan(b)]; }   // UX-B1: with the struck price
      countDown(c, plan(b));
    });
    var pl = card && at(card, 'data-plan');
    loadCelebrate().then(function (ign) { if (ign && pl) ign({ kind: 'coupon_applied', planID: pl, size: 'full', slot: $('.plan-price', card), id: 'coupon:' + state.code + ':' + pl }); });
  }, off && (off.top < nav || off.bottom > innerHeight) ? 450 : 0);
}
function armIO() {   // UX-B1: watch the PRICES — half of a 2,000-px pane is never on a phone screen
  var pane = $('[data-pane-checkout]'), io, tg;
  if (!pane || !state || !state.applied || state.celebrated || rm() || !window.IntersectionObserver) return;
  tg = $$('.plan-price', pane);
  io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (io && x.isIntersecting) { io.disconnect(); io = null; celebrate(x.target.closest('.pricing-card') || pane, { gesture: false }); } }); }, { threshold: 0.5 });
  (tg.length ? tg : [pane]).forEach(function (t) { io.observe(t); });
}
function onApplyClick(e) {
  e.preventDefault();
  var b = e.target.closest('.pay-code'), f = $('.pay-code-input', b), code = f.value.trim();
  armAudio();   // D-CU-6: inside the gesture, before any await
  if (!CODE_RE.test(code)) { msg(b, 'A code is 2 to 32 letters, digits, dashes or underscores.'); return f.focus(); }
  busy(b, true); msg(b);
  // UX-m4: reserve the applied height on EVERY card now, inside the press (the answer lands > 500 ms later, outside the input window)
  $$('.pay-code').forEach(function (x) { x.style.minHeight = ''; x.classList.add('is-pending'); });
  function unreserve() { $$('.is-pending').forEach(function (x) { x.classList.remove('is-pending'); }); }
  validate(code).then(function (res) {
    busy(b, false);
    if (!res.valid) { unreserve(); msg(b, res.message); say(res.message); return f.focus(); }   // CPN-UX-07: the server's sentence
    var keep = $$('.pay-code').map(function (x) { return x.offsetHeight; });
    apply(res, 'typed');
    $$('.pay-code').forEach(function (x, i) { if (x.offsetHeight < keep[i]) x.style.minHeight = keep[i] + 'px'; });   // never shrinks until the next press
    /* R100/X70: focus the chip WITHOUT scrolling and BEFORE celebrate() — a plain focus() after it cancelled the smooth scroll to the
       price (the drop played off-screen in 15 of 20 runs) */
    try { $('.pay-code-chip', b).focus({ preventScroll: true }); } catch (x) { $('.pay-code-chip', b).focus(); }
    celebrate(cardOf(b), { gesture: true });
  }, function (err) {
    var t = err && err.status === 429 ? 'Too many tries from this connection. Wait a minute and try again.' : E6;
    unreserve(); busy(b, false); msg(b, t); say(t); f.focus();
  });
}
function linkArrival() {
  var linkCode = urlCode();
  if (!linkCode) return;
  function done() { $$('.is-pending').forEach(function (b) { b.classList.remove('is-pending'); }); }
  validate(linkCode).then(function (res) { done(); if (res.valid) { apply(res, 'link'); armIO(); notice(res); } else write({ code: linkCode, invalid: true, at: now() }); }, done);
}
/* R105/X68: a return visit (the 90-day link value, no ?via this time) shows the same applied state — struck price, badge, Remove —
   with the celebration already spent, so nothing replays; Remove takes it off this visit's checkouts */
function storedArrival() {
  var c = null; try { c = clozoReferral.code(); } catch (e) {}
  if (!c || !CODE_RE.test(c)) return;
  validate(c).then(function (res) { if (!res.valid || state) return; apply(res, 'link'); state.celebrated = true; write(state); render(); }, function () {});
}
/* R088/X69: "Your 20% off is applied" on the first screen of ANY page the link lands on (phone included), once per visit */
function notice(res) {
  var css = root && at(root, 'data-coupon-css'), seen = null, n, x;
  try { seen = sessionStorage.getItem(NOTICE_KEY); } catch (e) {}
  if (seen === res.code) return;
  try { sessionStorage.setItem(NOTICE_KEY, res.code); } catch (e) {}
  function show() {
    n = mk('div', 'pay-code-notice'); n.setAttribute('role', 'status');
    var t = mk('span', 'pay-code-notice-t'); t.appendChild(mk('b', '', 'Your ' + (res.percentBps / 100) + '% off is applied')); t.appendChild(tx(' — the code ' + String(res.code).toUpperCase() + ' from your link takes it off your first month or year.'));
    x = mk('button', 'pay-code-notice-x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Close');
    n.appendChild(mk('span', 'pay-code-notice-i', '%')); n.appendChild(t); n.appendChild(x); D.body.appendChild(n);
    function bye() { if (n.parentNode) { n.classList.add('is-out'); setTimeout(function () { n.remove(); }, rm() ? 0 : 300); } }
    x.addEventListener('click', bye); setTimeout(bye, 9000);
  }
  if (!css || $('link[href*="/assets/css/coupon.css"]')) return show();
  var l = mk('link'); l.rel = 'stylesheet'; l.href = css; l.onload = show; D.head.appendChild(l);
}
window.clozoCoupon = {   // before the boot work: checkout.js reads it at DOMContentLoaded
  code: function () { return state && state.applied ? state.code : null; },
  pending: function () { try { return state ? null : clozoReferral.code() || null; } catch (e) { return null; } },   // CPN-UX-04
  state: function () { return state ? JSON.parse(JSON.stringify(state)) : null; },
  apply: function (code) { return validate(String(code || '').trim()).then(function (res) { if (res.valid) apply(res, 'typed'); return res; }); },
  clear: function (reason) {   // P4C-E2E (E2E flow 35b): a refused PENDING code is recorded too — else pending() kept returning it and checkout.js re-sent it on every retry
    if (state && state.applied) remove(reason, 1); else if (!state) { var c = null; try { c = clozoReferral.code(); } catch (e) {} if (c) write({ code: c, invalid: true, at: now() }); }
  },
  render: function () { state = read(); render(); }
};
function boot() {
  state = read();
  $$('.pay-code').forEach(function (b) { var c = cardOf(b); if (c) c.setAttribute('data-plan', plan(b)); });
  D.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('.pay-code-toggle')) open(t.closest('.pay-code'));
    else if (t.closest('.pay-code-remove')) remove('user');
    else if (t.closest('.pay-code-sound')) toggleSound();
    else if (t.closest('.plan-dropdown-item')) setTimeout(renderSticky, 0);
  });
  D.addEventListener('submit', function (e) { if (e.target.classList.contains('pay-code-form')) onApplyClick(e); });
  D.addEventListener('keydown', function (e) {
    var t = e.target.closest ? e.target : null, f = t && t.closest('.pay-code-form');
    if (e.key === 'Escape' && f) close(f.closest('.pay-code'));
    if ((e.key === 'Enter' || e.key === ' ') && t && t.closest('.plan-dropdown-item')) setTimeout(renderSticky, 0);
  });
  if (state && state.applied) {
    if (state.signedIn !== !!token()) afterLoad(function () {   // CPN-UX-05: signed in or out since the answer
      validate(state.code).then(function (res) { if (res.valid) { apply(res, state.src); armIO(); } else remove('revalidate', 1); }, function () { render(); armIO(); });
    });
    else { render(); armIO(); }
  } else if (!state) {
    if (urlCode()) { $$('.pay-code').forEach(function (b) { b.classList.add('is-pending'); }); afterLoad(linkArrival); }   // CPN-UX-02: reserve the applied height
    else afterLoad(storedArrival);
  }
  afterLoad(function () {   // D-CU-17: the owner withdrew the discount
    try { __clozoRuntime.config(function (cfg) { if (cfg && cfg.coupon && cfg.coupon.enabled === false) { $$('.pay-code, [data-pay-code-note]').forEach(function (n) { n.hidden = true; }); if (state && state.applied) remove('disabled', 1); } }); } catch (e) {}
  });
}
if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
